import { Application } from "stimulus"
import { definitionsFromContext } from "stimulus/webpack-helpers"

export function start() {
  const application = Application.start()
  const context = require.context("src/stimulus/controllers", true, /_controller\.js$/)

  application.load(definitionsFromContext(context))
}